import React, { useCallback } from "react";
import { connect } from "react-redux";
import FormField from '../../../../../dynamicFormBuilder/FormField';
import { CommentsLayout } from '../Layout';

function CommentsTab(props) {
    var currentUser = props.oidc?.user;
    const DYNAMICFORMSETTING = props.oidc?.user?.profile?.DYNAMICFORMSETTING;

    const handleFieldValueChange = useCallback((name, value) => {
        props.handleFieldChange(name, value);
    }, [props.handleFieldChange]);

    const onFormLoad = useCallback(() => {}, []);

    return (
        <div>
            <FormField
                currrentUser={currentUser}
                layoutId='ED2A284D-BA73-4267-B676-DD26FB73483C'
                layoutName='WMSchedulesManagementCommentsForm'
                defaultFormSchema={CommentsLayout}
                formFields={props.formFields}
                setformFields={props.setformFields}
                handleFieldValueChange={handleFieldValueChange}
                DYNAMICFORMSETTING={DYNAMICFORMSETTING}
                formRefs={props.formRefs}
                onFormLoad={onFormLoad}
            />
        </div>
    );
}

function mapStateToProps(state) {
    return {
        oidc: state.oidc
    };
}

export default connect(mapStateToProps)(CommentsTab);
